window.ShapedaysVariantSelector = (function () {
  var COLOR_HEX_MAP = {
    'ベージュ': '#D7BCA6',
    'ブラック': '#12171B',
    'ダスティーブルー': '#7F98D7',
    'ピンク': '#EFDCE5',
    'テラコッタ': '#BD665E',
    'サックスブルー': '#D7E0EC',
    'ネイビー': '#000080',
    'グレー': '#BFB8B1'
  };
  var DEFAULT_SWATCH_HEX = '#D9D9D9';

  function formatMoney(cents) {
    return Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function applyColorHex(root) {
    root.querySelectorAll('.pkg-swatch').forEach(function (btn) {
      var name = (btn.getAttribute('data-value') || '').trim();
      var hex = COLOR_HEX_MAP[name] || DEFAULT_SWATCH_HEX;
      var ringPath = btn.querySelector('.pkg-swatch-ring path');
      var fillPath = btn.querySelector('.pkg-swatch-fill path');
      if (ringPath) ringPath.setAttribute('stroke', hex);
      if (fillPath) fillPath.setAttribute('fill', hex);
    });
  }

  function initCard(card) {
    var variantsScript = card.querySelector('[data-variants-json]');
    if (!variantsScript) return;
    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      return;
    }

    var sizeGroup = card.querySelector('[data-size-group]');
    var colorGroup = card.querySelector('[data-color-group]');
    var sizeIndex = sizeGroup ? parseInt(sizeGroup.getAttribute('data-option-index'), 10) : -1;
    var colorIndex = colorGroup ? parseInt(colorGroup.getAttribute('data-option-index'), 10) : -1;

    var img = card.querySelector('[data-product-img]');
    var spinner = card.querySelector('[data-product-spinner]');
    var priceSale = card.querySelector('[data-price-sale]');
    var priceCompare = card.querySelector('[data-price-compare]');
    var priceCompareWrap = card.querySelector('[data-price-compare-wrap]');
    var priceDiscount = card.querySelector('[data-price-discount]');
    var variantInput = card.querySelector('[data-variant-id]');
    var addBtn = card.querySelector('[data-add-cart-btn]');

    var currentSrc = img ? img.getAttribute('src') : null;

    if (img) {
      img.addEventListener('error', function () {
        if (spinner) spinner.classList.remove('is-visible');
      });
    }

    var selectedSizeBtn = sizeGroup ? sizeGroup.querySelector('.is-selected') : null;
    var selectedSize = selectedSizeBtn ? selectedSizeBtn.getAttribute('data-value') : null;
    var selectedColorBtn = colorGroup ? colorGroup.querySelector('.is-active') : null;
    var selectedColor = selectedColorBtn ? selectedColorBtn.getAttribute('data-value') : null;

    function findVariant() {
      return variants.filter(function (v) {
        var sizeOk = sizeIndex < 0 || v.options[sizeIndex] === selectedSize;
        var colorOk = colorIndex < 0 || v.options[colorIndex] === selectedColor;
        return sizeOk && colorOk;
      })[0];
    }

    function resizeSrc(src, width) {
      if (!src) return src;
      var sep = src.indexOf('?') === -1 ? '?' : '&';
      return src + sep + 'width=' + width;
    }

    function swapImage(src) {
      if (!img || !src || src === currentSrc) return;
      var oldSrc = currentSrc;
      currentSrc = src;

      /* True crossfade, same feel as the detail page's slide transition:
         put a "ghost" of the OLD image on top of the real <img>, swap the
         real <img> to the new src underneath (instant if cached, otherwise
         once preloaded), then fade the ghost away to reveal it. */
      function reveal() {
        if (spinner) spinner.classList.remove('is-visible');

        /* Match the ghost's box to the real <img>'s current rendered
           geometry exactly (offset/size/object-fit) — some cards use
           full-bleed cover images, others center a smaller intrinsic-sized
           photo via flex, so a fixed inset:0/100% guess doesn't fit both. */
        var ghost = null;
        if (oldSrc && img.parentNode) {
          ghost = document.createElement('img');
          ghost.src = oldSrc;
          ghost.className = 'product-card-ghost';
          ghost.style.top = img.offsetTop + 'px';
          ghost.style.left = img.offsetLeft + 'px';
          ghost.style.width = img.offsetWidth + 'px';
          ghost.style.height = img.offsetHeight + 'px';
          ghost.style.objectFit = getComputedStyle(img).objectFit || 'cover';
          img.parentNode.insertBefore(ghost, img.nextSibling);
        }

        img.src = src;

        if (!ghost) return;
        requestAnimationFrame(function () {
          ghost.classList.add('is-fading-out');
        });
        setTimeout(function () {
          if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
        }, 400);
      }

      var preload = new Image();
      preload.src = src;
      if (preload.complete) {
        reveal();
      } else {
        if (spinner) spinner.classList.add('is-visible');
        preload.addEventListener('load', reveal);
        preload.addEventListener('error', function () {
          if (spinner) spinner.classList.remove('is-visible');
        });
      }
    }

    function filterColorsForSize(sizeValue) {
      if (!colorGroup || sizeIndex < 0 || colorIndex < 0 || !sizeValue) return;
      var visible = [];
      colorGroup.querySelectorAll('.pkg-swatch').forEach(function (btn) {
        var colorValue = btn.getAttribute('data-value');
        var exists = variants.some(function (v) { return v.options[sizeIndex] === sizeValue && v.options[colorIndex] === colorValue; });
        btn.style.display = exists ? '' : 'none';
        if (exists) visible.push(btn);
      });
      var activeColor = colorGroup.querySelector('.pkg-swatch.is-active');
      if (activeColor && activeColor.style.display === 'none' && visible.length) {
        colorGroup.querySelectorAll('.pkg-swatch').forEach(function (b) { b.classList.remove('is-active'); });
        visible[0].classList.add('is-active');
        selectedColor = visible[0].getAttribute('data-value');
      }
    }

    function updateCard() {
      var variant = findVariant();
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;

      var imageSource = variant;
      if ((!imageSource.featured_image || !imageSource.featured_image.src) && colorIndex > -1) {
        var sameColor = variants.find(function (v) {
          return v.options[colorIndex] === variant.options[colorIndex] && v.featured_image && v.featured_image.src;
        });
        if (sameColor) imageSource = sameColor;
      }
      if (imageSource.featured_image && imageSource.featured_image.src) {
        swapImage(resizeSrc(imageSource.featured_image.src, 500));
      }

      if (priceSale) priceSale.textContent = formatMoney(variant.price);

      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceCompareWrap) priceCompareWrap.style.display = hasCompare ? '' : 'none';
      if (priceCompare && hasCompare) priceCompare.textContent = formatMoney(variant.compare_at_price);
      if (priceDiscount) {
        priceDiscount.style.display = hasCompare ? '' : 'none';
        if (hasCompare) {
          /* Math.floor, not Math.round: must match the Liquid initial render
             (product-card.liquid / campaign-colors.liquid), which uses
             integer `divided_by` (floor division) — otherwise the same
             variant shows a different %OFF before vs after a swatch click. */
          var off = Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          priceDiscount.textContent = off + '%OFF';
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? '購入' : '売り切れ';
      }
    }

    if (sizeGroup) {
      sizeGroup.querySelectorAll('.campaign-size-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizeGroup.querySelectorAll('.campaign-size-btn').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          selectedSize = btn.getAttribute('data-value');
          filterColorsForSize(selectedSize);
          updateCard();
        });
      });
    }

    if (colorGroup) {
      colorGroup.querySelectorAll('.pkg-swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          colorGroup.querySelectorAll('.pkg-swatch').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          selectedColor = btn.getAttribute('data-value');
          updateCard();
        });
      });
    }

    filterColorsForSize(selectedSize);
  }

  function initAll(root) {
    root = root || document;
    root.querySelectorAll('[data-product-card]').forEach(function (card) {
      applyColorHex(card);
      initCard(card);
    });
  }

  /* Exposed so other inline scripts (product-page.liquid, cart.liquid) can
     reuse this instead of each declaring their own copy — this file loads
     unconditionally, without `defer`, from <head> (theme.liquid), so it's
     always defined before any later inline <script> in <body> runs. Keep it
     that way: adding `defer` here would reverse that ordering. */
  return { initAll: initAll, formatMoney: formatMoney };
})();
